/* eslint-disable max-len */
import VRAQuestion from 'images/coin-pages/questions/vra.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const vraPage: ICoinPageData = {
  title: 'coin_1118',
  description: 'coin_1119',
  // description: 'coin_1120',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Verasity (VRA)' }) }} />
  ),
  questionsBlock: {
    image: VRAQuestion,
    questions: [
      {
        title: 'coin_1121',
        answer: 'coin_1122',
      },
      {
        title: 'coin_1123',
        answer: 'coin_1124',
      },
      {
        title: 'coin_1125',
        answer: 'coin_1126',
      },
      {
        title: 'coin_1127',
        answer: 'coin_1128',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Verasity (VRA)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_1129',
        text: ['coin_1131', 'coin_1132'],
      },
      {
        title: 'coin_1130',
        text: ['coin_1133'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/vra/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/06/Gain-profit.png',
        imageAlt: 'Hold VRA & Gain profit',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
